<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute
    }"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">{{getRouteName($route.name)}}</h3>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          
<!--           <div class="md-autocomplete">
            <md-autocomplete
              class="search"
              v-model="selectedEmployee"
              :md-options="employees"
              :md-open-on-focus="false"
            >
              <label v-if="$route.meta.rtlActive">بحث...</label>
              <label v-else>Search...</label>
            </md-autocomplete>
          </div> -->

           <md-list>

               <li class="md-list-item">
                <!-- <div class="md-list-item-content"> -->
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                      @click="notificationView"
                    >
                      <md-icon>notifications</md-icon>
                      <span v-if="showNotificationCounter" class="notification">{{notificationCounter}}</span>
                      <p class="hidden-lg hidden-md">Notifications</p>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li v-for="item in notifications" v-bind:key="item.id">
                        <a v-if="item.type == 'NILM' && item.data.event == 'ON'" href="#">
                          {{getFormattedTime(item.data.timestamp)}}: {{$lang.general.appliance_on}}
                          <br>
                          {{item.data.name}}<br>
                          {{$lang.charts.phase}} {{item.data.phase}}
                          </a>

                        <a v-if="item.type == 'NILM' && item.data.event == 'OFF'" href="#">
                          {{getFormattedTime(item.data.timestamp)}}: {{$lang.general.appliance_off}}
                          <br>
                          {{item.data.name}}<br>
                          {{$lang.charts.phase}} {{item.data.phase}}<br>
                          {{$lang.general.energy_consumption}} {{Number(item.data.energy_consumption_wh).toFixed(1)}} Wh
                          </a>
                        </li>
                    </ul>
                  </drop-down>
                <!-- </div> -->
            </li>

          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import format from "date-fns/format";

export default {
  data() {
    return {
      showNotificationCounter: false,
      notificationCounter: 0
    };
  },

  computed: {
    notifications() {
      return this.$store.getters.getNotificationList;
    }
  },

  watch: {
    notifications: function(payload, oldPayload) {
      this.showNotificationCounter = true;
      this.notificationCounter++;
    }
  },

  methods: {
    getFormattedTime(timestamp){
      return format(timestamp * 1000, "HH:mm:ss");
    },
    getRouteName(routeName){
      return routeName;
    },
    notificationView(){
      this.showNotificationCounter = false;
      this.notificationCounter = 0;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  }
};
</script>

<style lang="scss" scoped>

.location-flag {
  padding-right:10px;
}
</style>
